import actions from "../actions/actions";

const INITIAL_VALUE = {
	addresses: [],
	listLoading: false,
	activeMeterTypes: [],
	meterTypes: [],
	itemLoading: false,
	meters: [],
	changedMeters: {},
	allAddresses: [],
	tags: [],
};

export default (state = INITIAL_VALUE, action) => {
	switch (action.type) {
		case actions.LIST_LOADING:
			return {
				...state,
				listLoading: true,
			};
		case actions.ADDRESSES_LOADED:
			return {
				...state,
				listLoading: false,
				addresses: action.payload,
			};
		case actions.ALL_ADDRESSES_LOADED:
			return {
				...state,
				allAddresses: action.payload,
			};
		case actions.ITEM_LOADING:
			return {
				...state,
				itemLoading: true,
				meters: action.payload,
			};
		case actions.METERS_LOADED:
			return {
				...state,
				itemLoading: false,
				meters: [...action.payload],
			};
		case actions.SET_FILTRATION:
			return {
				...state,
				activeMeterTypes: action.payload,
			};
		case actions.METER_TYPES_LOADED:
			return {
				...state,
				listLoading: false,
				meterTypes: action.payload,
			};
		case actions.METER_TAGS_LOADED:
			return {
				...state,
				tags: action.payload,
			};
		case actions.METER_CHANGED:
			return {
				...state,
				changedMeters: {
					...state.changedMeters,
					[`${action.payload.meterId} ${action.payload.tariffId}`]:
						action.payload,
				},
			};
		case actions.METER_CHANGED_TO_PREV_VALUE:
			const changedMeters = {
				...state.changedMeters,
			};
			delete changedMeters[
				`${action.payload.meterId} ${action.payload.tariffId}`
			];
			return {
				...state,
				changedMeters,
			};
		case actions.SAVED_METER_CHANGING:
			return {
				...state,
				changedMeters: {},
			};
		default:
			return state;
	}
};
